import { DatePipe } from '@angular/common';
import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {select, Store} from "@ngrx/store";
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService, IndividualConfig } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { ExtensionSmartService } from 'src/app/services/extension-smart.service';
import { HostService } from 'src/app/services/host.service';
import { LocationSmartService } from 'src/app/services/location-smart.service';
import { RentingService } from 'src/app/services/renting.service';
import { ChoosePaymentMethodComponent } from 'src/app/shared/choose-payment-method/choose-payment-method.component';
import { RentingMessageComponent } from 'src/app/shared/renting-message/renting-message.component';
import { Dashboard } from 'src/app/state/dashboard';
import { DashboardSelector } from 'src/app/state/dashboard.selector';
import { VerifResponsiveService } from 'src/app/services/verif-responsive.service';

@Component({
  selector: 'app-latest-orders',
  templateUrl: './latest-orders.component.html',
  styleUrls: ['./latest-orders.component.scss']
})
export class LatestOrdersComponent implements OnInit, OnDestroy {

  rentings$: Observable<Dashboard> = this.store.pipe(select(DashboardSelector));
  rentingsOwner: Array<any>;
  rentingsLogder: Array<any>;
  @Input('userRole') userRole:string|any;
  public lazyLoad: boolean = false;
  public viewType: string = "list";
  public column: number = 4;
  public p: number = 1;


  //Subscription
  changeStatusSubscription: Subscription;

  //Boolean
  statusChanged: boolean = false;

  currentDate: string | null;

  public currency: string;

  constructor(private store: Store,
              public hostService: HostService,
              private appService: AppService,
              private locationSmartService: LocationSmartService,
              private spinner: NgxSpinnerService,
              private rentingService: RentingService,
              private toastr: ToastrService,
              private datePipe: DatePipe,
              private dialog: MatDialog,
              private verifResponsiveService:VerifResponsiveService,
              private extensionSmartService: ExtensionSmartService) {
                
                this.currentDate =  this.datePipe.transform(Date.now(), 'yyyy-MM-dd')

              }


  ngOnInit(): void {
           
      this.currency = this.appService.getCurrency();
      this.verifResponsiveService.confirmResponsive().subscribe((data) => {
        console.log(data);
        this.viewType = data ? 'grid' : 'list';
      });

  }

   @HostListener('window:resize', ['$event'])
    onResize() {
      if(window.innerWidth<=959)
      {
        this.viewType= 'grid';
      }
      else{
        this.viewType= 'list';
      }
    }
    

  public viewRenting(idRenting: number, status: string, message: string, key: string) {
   
    let obj = {
      'idRenting': idRenting,
      'status': status,
      'message': message,
      'key': key,
    }
    
		this.appService.openDialogGalsenMessage(RentingMessageComponent, obj, 'theme-dialog');
			 
  }

  // public changeStatus(renting: Object, status: string, key: string) {

  // }

  public changeStatus(renting: any, status: string, key: string) {

    let user = JSON.parse(sessionStorage.getItem("user")!)

    this.spinner.show();

    if(renting.renting_status == "PAYER" && status == "ANNULER") {

      this.locationSmartService.changeStatusAfterPayment(renting, status, key);

      this.rentingService.indexLodger(user.id).subscribe((response: any) => {

        this.rentingsLogder = response['rentings'];

      })

      this.rentingService.indexOwner(user.id).subscribe((response: any) => {

        this.rentingsOwner = response['rentings'];

        this.statusChanged = true;

        this.spinner.hide();

      })
      
    } else {

      let obj = {
        id: renting.id,
        status: status,
        idUser: user.id,
      };

      this.changeStatusSubscription = this.rentingService
      .changeStatusOnDashboard(obj)
      .subscribe((response: any) => {

        this.rentingsOwner = response['owner'];
        this.rentingsLogder = response['logder'];
        
        this.spinner.hide();

        this.statusChanged = true;
        
        this.toastr.show("Le status de la réservation a été modifié","Status Changé",
          {
            timeOut: 5000,
            closeButton: true,
          } as IndividualConfig,
          "toast-" + "success"
        );

        console.log(response);

      });


    }
   
  }

  /**
   * On selectionner le moyen de paiement avant de proceder au paiement
  */
  public choosePaymentMethod(idRenting: number) {

    const dialogRef = this.dialog.open(ChoosePaymentMethodComponent, {
      data: {
        id: idRenting,
        key: 'payment',
        for: 'renting'
      },
      disableClose: true
    });

  }

  /**
   * Prolonger la reservation
   * 
   * @param renting 
   */
  extension(renting: any) {

    // console.log(renting);

    this.extensionSmartService.OpenModalExtension(renting);

  }

  ngOnDestroy(): void {
    
    if(this.statusChanged) {

      this.changeStatusSubscription.unsubscribe();

    }
  }

  
  changeViewType(viewType:string)
  {
    this.viewType = viewType;
  }


}
